import {Component, ElementRef, HostListener, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {ContactUsService} from "../../../shared/services/contact-us.service";
import {AlertService} from "../../../shared/services/alert.service";
import {Meta, Title} from "@angular/platform-browser";

@Component({
    selector: 'app-db-devops-serverless',
    templateUrl: './db-devops-serverless.component.html',
    styleUrls: ['./db-devops-serverless.component.scss']
})
export class DbDevopsServerlessComponent implements OnInit {

    @ViewChild('contactFormModal') contactFormModal!: TemplateRef<any>;
    @ViewChild('videoElement') videoElement!: ElementRef<HTMLVideoElement>;
    isModalOpen = false;
    contactForm: FormGroup;
    submitted: any = false;
    submitting: any = false;
    successMessage: string;

    whyChoose1 = [
        {
            header: 'Automated Audits',
            icon: 'fa-regular fa-life-ring',
            text: 'We provide comprehensive support for various applications, collect and organize audit evidence digitally helping your team get rid of mountains of paperwork and inconsistency through our automated processes.  '
        },
        {
            header: 'Real-Time Compliance Tracking',
            icon: 'fa-regular fa-clock',

            text: ' We offer an easy-to-navigate dashboard designed to support your business requirements. Additionally, monitor your cloud compliance audit in real time.'
        },
        {
            header: 'Data Security ',
            icon: 'fa-regular  fa-eye',

            text: 'Data safety is always on our priority list. Thus, we ensure your IT infrastructure or SaaS platform meets the most updated security requirements using numerous tools and techniques.'
        },
        {
            header : 'Cost Efficiency',
            icon: 'fa-regular fa-money-bill-1',

            text : 'To avoid or reduce the risk of expensive breaches or penalties, we use numerous cost-effective resources to address vulnerabilities and streamline the compliance process which saves time and money as well.'
        }
    ];
    benifits = [
        {
            header: 'Comprehensive Protections',
            icon: 'fa-regular fa-life-ring',
            text: 'From the development of an application to auditing and compliance in cloud computing, and data storage, Volmint offers end-to-end security solutions that highlight every aspect of your digital infrastructure.'
        },
        {
            header: 'Regulatory Confidence',
            icon: 'fa-regular fa-clock',

            text: '  Our focus is to fill the gap and allow your organization to meet global standards like SOC2, CASA2, and ISO 27001 certifications. With our expert cloud compliance audit and consulting, stay ahead of regulatory requirements.'
        },
        {
            header: 'Tailored Solutions',
            icon: 'fa-regular  fa-eye',

            text: 'Our motto is to transform your business. Thus, our services are customized that align with your specific business needs. Our security compliance services ensure optimal performance and protection without any hassle.'
        },
        {
            header : 'Expert Support',
            icon: 'fa-regular fa-money-bill-1',
            text : 'From consultation to design and delivery, we offer expert guidance at every step so that you can make the most of it with our services. We have a team of experts who are dedicated to your success so that you can focus on business growth.'
        },
        {
            header : 'Enhanced Operational Efficiency',
            icon: 'fa-regular fa-money-bill-1',
            text : ' We don’t just offer personalized solutions to your businesses, we ensure a secure system that optimizes workflow and allows your team to focus on another valuable task in favor of the organization.'
        },
    ];

    selectedIndex= 0
    tabs = [
        {
            title: 'DevSecOps Services',
            paragraph: 'DevSecOps services provide a secure and seamless development lifecycle. By integrating security applications into each phase of development, we ensure the applications are smooth and resilient to threats. This unique approach allows for to reduction of vulnerabilities, cost, and risk and increases security. ',
            content: {
                img: 'assets/img/landing-new/db-devops-serverless/consult.png',
                heading : ' DevSecOps A Holistic Approach to Secure Development',
                detail:'At Volmint Technologies, our DevSecOps services are designed to integrate security throughout the development process. We focus on three key areas: SAST integration, DAST integration, and Web security, ensuring your applications are secure from code to deployment.\n',
                list:[
                    `SAST Integration (Static Application Security Testing) — The SAST integration service allows for the analysis of vulnerabilities in the source code at very early stages of the development process. By evaluating issues at the initial stages, we can address proactive risks that help reduce time and money while fixing the issues.`,
                    ' DAST Integration (Dynamic Application Security Testing) —  The DAST integration services allow you to focus on real-world attacks that may harm your application while it’s running. They help detect and address vulnerabilities that might be missed during static testing and ensure protection against threats that may arise in a live environment.',
                    ' Web Security —  Our web security services protect your web applications through robust technical strategies and techniques. We safeguard your application from common threats like SQL injection, cross-site scripting (XSS), and other web attacks, ensuring that your online assets remain secure and protected.'
                ]
            },
        },
        {
            title: ' Compliance Audit and Consulting',
            paragraph: ' Auditing and compliance in cloud computing allow us to address the complexities of regulatory frameworks with ease. We specialize in maintaining compliance and optimizing the process from ISO 27001 and CASA2 to SOC 2 --like certifications for better efficiency and effectiveness.',
            content: {
                img: 'assets/img/landing-new/db-devops-serverless/info.png',
                heading : ' Streamline Compliance and Simplify Audits To Reduce Risk',
                detail:'Through our Compliance Audit and Consulting services, we ensure your business stays compliant while optimizing processes for greater efficiency. Our services keep your business compliant with ISO 27001 and CASA2 to SOC 2 --like certifications.\n',
                list:[
                    'ISO 27001 — Our ISO 27001 compliance services assist appropriate teams in establishing, implementing, and maintaining an information security management system (ISMS),  protect your data, and enhance trust among clients and partners.',
                    'SOC2 —  The SOC2 service focuses on the availability, security, confidentiality, integrity, and privacy of customer data. We assist organizations in SOC2 auditing, ensuring compliance with stringent criteria, especially for cloud-based customer data handling.',
                    ' CASA2 — For the specialized regulatory frameworks regarding cybersecurity and data privacy, we offer CASA2 services tailored to the organization\'s needs, ensuring your business remains compliant and secure.'
                ]
            },
        },
        {
            title: 'IT Consulting Services',
            paragraph: 'Our expert consulting services help to protect your IT infrastructure in this ever-evolving digital landscape. Our strategies are designed to meet the requirements of business while enhancing security measures and ensuring compliance. We guide teams to thrive in a secure and compliant manner.',
            content: {
                img: 'assets/img/landing-new/db-devops-serverless/business.png',
                heading : 'Experience Rapid Growth in Your Business With IT Consulting Services',
                detail:'Volmint Technologies offers a wide range of IT Consulting Services that are designed to support your business’s IT infrastructure. From All Domains, including Application Development to Time and Material-based contracts and SLA-based contracts, we cover it all!',
                list:[
                    'All Domains, Including Application Development  — With a focus on the development of high-performing applications, we provide comprehensive IT consulting services across all domains. Whether your business demands custom mobile applications, software, or enterprise-level solutions, we design, develop, and deliver applications while ensuring security and scalability.',
                    'Time and Material-Based Contract — We offer time and material-based contract services that allow flexible engagement for businesses following evolving project needs. This model saves time and money, making sure that our clients get the right expertise at the right time. The service is an ideal option for those projects where the scope is inconsistent and provides cost control.',
                    'SLA-Based Contracts —  Our SLA-Based Contracts guarantee service levels and performance metrics. It is a highly in-demand service for clients looking to have predictable outcomes. Our team of experts works with your team to address key deliverables and ensure that our services meet or exceed the agreed-upon standards. This helps to provide reliability for critical business operations.'
                ]
            },
        },
    ];

    constructor(
        private router: Router,
        private fb: FormBuilder,
        private contactService: ContactUsService,
        private alertService: AlertService,
        private title: Title,
        private meta : Meta
    ) {
    }

    ngOnInit(): void {
        this.updateMetaTags()
        this.refresh();
    }

    refresh() {
        this.contactForm = this.fb.group({
            name: ['', Validators.required],
            email: ['', [Validators.required, Validators.email]],
            contact: [''],
            subject: ['', Validators.required],
            message: ['', Validators.required]
        });
    }

    openModal() {
        this.isModalOpen = true;
    }

    closeModal() {
        this.isModalOpen = false;
    }

    handleOverlayClick(event: MouseEvent) {
        const target = event.target as HTMLElement;
        if (!target.closest('.modal-dialog')) {
            this.closeModal();
        }
    }


    selectTab(index: number) {
        this.selectedIndex = index;
    }

    submit() {
        this.submitted = true;
        if (!this.contactForm.valid) {
            return;
        }
        if (this.submitted) {
            const params = {
                'name': (this.contactForm && this.contactForm.getRawValue() && this.contactForm.getRawValue().name) ? this.contactForm.getRawValue().name : '',
                'email': (this.contactForm && this.contactForm.getRawValue() && this.contactForm.getRawValue().email) ? this.contactForm.getRawValue().email : '',
                'contact': (this.contactForm && this.contactForm.getRawValue() && this.contactForm.getRawValue().contact) ? this.contactForm.getRawValue().contact : '',
                'subject': (this.contactForm && this.contactForm.getRawValue() && this.contactForm.getRawValue().subject) ? this.contactForm.getRawValue().subject : '',
                'message': (this.contactForm && this.contactForm.getRawValue() && this.contactForm.getRawValue().message) ? this.contactForm.getRawValue().message : '',
            };
            this.contactService.create(params).subscribe(data => {
                this.successMessage = 'Your form has been submitted successfully!';
                this.submitted = false;
                this.contactForm.patchValue({
                    'name': '',
                    'email': '',
                    'contact': '',
                    'subject': '',
                    'message': ''
                });
            }, error => {
                this.submitting = false;
                this.submitted = false;
                if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
                    if (error['error']['errors'].email && error['error']['errors'].email.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].email[0]);
                        return;
                    }
                    if (error['error']['errors'].name && error['error']['errors'].name.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].name[0]);
                        return;
                    }
                    if (error['error']['errors'].contact && error['error']['errors'].contact.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].contact[0]);
                        return;
                    }
                    if (error['error']['errors'].subject && error['error']['errors'].subject.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].subject[0]);
                        return;
                    }
                    if (error['error']['errors'].message && error['error']['errors'].message.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].message[0]);
                        return;
                    }
                }
            });
        }
    }

    playVideo() {
        const video = this.videoElement.nativeElement;
        const thumbnail = document.getElementById('video-thumbnail');
        if (video) {
            video.classList.remove('d-none');
            video.play();
            if (thumbnail) {
                thumbnail.style.display = 'none';
            }
            const playButton = document.querySelector('.play-button');
            if (playButton) {
                playButton.classList.add('d-none');
            }
        }
    }

    goTo(url) {
        this.router.navigateByUrl(url);
    }

    @HostListener('window:scroll', [])
    onWindowScroll() {
        const elements = document.querySelectorAll('.animate-on-scroll');
        const scrollPosition = window.innerHeight + window.scrollY;

        elements.forEach((element) => {
            const elementPosition = element.getBoundingClientRect().top + window.scrollY;
            if (scrollPosition >= elementPosition) {
                element.classList.add('visible'); // Add the visible class when in view
            }
        });

        const elements1 = document.querySelectorAll('.animate-on-scroll-right');
        const scrollPosition1 = window.innerHeight + window.scrollY;
        elements1.forEach((element) => {
            const elementPosition = element.getBoundingClientRect().top + window.scrollY;

            if (scrollPosition1 >= elementPosition) {
                element.classList.add('visible'); // Add the visible class when in view
            }
        });
    }

    updateMetaTags() {
        this.title.setTitle('Security & Compliance Services | DevSecOps & Cloud Security Experts');
        this.meta.updateTag({
            name: 'description',
            content: 'Enhance security & compliance with expert DevSecOps services. Safeguard your IT infrastructure with ISO 27001, SOC 2, SAST, & DAST solutions. Stay secure, stay compliant! '

        });
        this.meta.updateTag({
            name: 'keyword',
            content: ' cloud based computing security, auditing in cloud computing, auditing and compliance in cloud computing, security and compliance services, cloud compliance audit, compliance audit consultant, security compliance services, devsecops services, compliance in cloud computing'

        });
    }

}
